import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-alumni-office-contacts',
  templateUrl: './alumni-office-contacts.component.html',
  styleUrls: ['./alumni-office-contacts.component.scss']
})
export class AlumniOfficeContactsComponent implements OnInit {
    alumniOfficeContacts = [
        {
            school: 'ARNI School of Technology',
            name: 'Dr. Gurvinder Singh',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Business Management & Commerce',
            name: 'Dr. Irshad Ahmad Sofi',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Art & Humanities',
            name: 'Dr. Brijesh Tiwari',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Basic Sciences & Bio-Technology',
            name: 'Dr. Manish Kumar Srivastava',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Allied Health Sciences',
            name: 'Dr. Tahseen Bilal Rather',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Pharmacy',
            name: 'Prof. (Dr.) Neeraj Bhandari',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Agriculture',
            name: 'Dr. Jai Prakash Thakur',
            email: '',
            designation: 'Dean',
        },
        {
            school: 'ARNI School of Law',
            name: 'Dr. Sudhir Kumar Pal',
            email: '',
            designation: 'HOD, Associate Professor',
        },
        {
            school: 'ARNI School of Hotel Management & Tourism',
            name: 'Dr. Deepak Dubey',
            email: '',
            designation: 'HOD',
        },
    /*    {
            school: 'ARNI School of Education & Sports',
            name: '',
            email: '',
            designation: 'Dean',
        }*/
    ];

    constructor(private router: Router) { }

  ngOnInit(): void {}

}
